<template>
  <v-select
    :items="taxes.edges"
    v-model="selectedTaxType"
    :label="taxLabel"
    item-text="node.code"
    item-value="node"
    :error-messages="errorMessages"
    @change="onChange"
    :outlined="outlined"
    :hide-details="hideDetails"
  ></v-select>
</template>

<script>
import { TAXES_QUERY } from "../../../constants/graphql";

export default {
  name: "TaxesListSelect",

  props: {
    value: {
      type: String,
      default: () => "",
    },
    taxCode: {
      type: String,
      default: "",
    },
    taxType: {
      type: String,
      default: "",
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
    customLabel: {
      type: String,
      default: "",
    },
    doResetSelectedTax: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: () => false,
    },
    hideDetails: {
      type: Boolean,
      default: () => false,
    },
    useName: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      selectedTaxType: {},
      taxes: {},
    };
  },

  computed: {
    taxLabel() {
      return this.customLabel !== "" ? this.customLabel : "Tax Code";
    },
  },

  methods: {
    onChange(payload) {
      this.$emit("onSelectTaxType", payload);
      this.$emit("input", payload.code);
    },
    setSelectedTaxType() {
      let value = this.taxCode ? this.taxCode : this.taxType;
      let field = this.taxCode ? "code" : "description";

      if (this.value != "") {
        value = this.value;
        field = "code";
      }
      this.selectedTaxType =
        this.taxes.edges.find((item) => {
          return item.node[field] === value;
        }) || {};
    },
  },

  watch: {
    value(newVal) {
      const taxType = this.taxes.edges.find((item) => {
        return item.node.code === newVal;
      });
      if (taxType) {
        this.selectedTaxType = taxType;
      }
    },
    taxCode(value) {
      const taxType = this.taxes.edges.find((item) => {
        return item.node.code === value;
      });
      if (taxType) {
        this.selectedTaxType = taxType;
      }
    },

    taxType(value) {
      const taxType = this.taxes.edges.find((item) => {
        return item.node.description === value;
      });
      if (taxType) {
        this.selectedTaxType = taxType;
      }
    },

    doResetSelectedTax(value) {
      if (value) {
        this.selectedTaxType = {};
        this.$emit("onSelectedTaxReset");
      }
    },
    value() {
      this.setSelectedTaxType();
    },
  },

  apollo: {
    taxes: {
      query: TAXES_QUERY,

      result() {
        this.setSelectedTaxType();
      },
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/gt/shared/TaxesListSelect.vue